4 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button type="primary" @click="exportExcel">导出数据</el-button>
        </div>
        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10" ><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;</span>特属专家：</span>
                <el-input v-model="doctor_name" placeholder="特属专家模糊搜索"/>
            </el-col>
            <el-col :md="9" :lg="5" :xl="6" :sm="6" :xs="24">
                <span class="fs-14 pd-r-10">起止时间：</span>
                <el-date-picker
                    v-model="search_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24" v-if="type == 2">
                <span class="fs-14 pd-r-10">特属服务对象：</span>
                <el-input v-model="user_name" placeholder="特属服务对象模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24" v-if="type == 2">
                <span class="fs-14 pd-r-10">报表类型：</span>

                <el-select v-model="type" style="width: 100%;max-width: none !important;" @change="searchStatus" placeholder="请选择报表类型">
                    <el-option
                        v-for="item in allType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24" v-else>
                <span class="fs-14 pd-r-10" ><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;</span>报表类型：</span>
                <el-select v-model="type" style="width: 100%;max-width: none !important;"   @change="searchStatus" placeholder="请选择报表类型">
                    <el-option
                        v-for="item in allType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>



        <!-- 表单结束 -->
        <p style="float: left;">超时未回复统计：{{allData}}</p>
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="doctor_name" label="特属专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="doctor_mobile" label="特属专家联系电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="hospital_name" label="特属专家单位" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="department_name" label="特属专家科室" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="特属服务对象" align="center" label-class-name="label" v-if="type == 2"></el-table-column>
            <el-table-column prop="user_mobile" label="特属服务对象联系电话" align="center" label-class-name="label" v-if="type == 2"></el-table-column>
            <el-table-column prop="number" label="超时未回复次数" align="center" label-class-name="label"></el-table-column>
        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
import {getUserInfos} from '@/utils/userInfos'
import {getFormatDate} from "@/utils/date";
import {check} from "@/utils/checkData";
import {authUrlCheck, isMobile} from "@/api/order";
import {export2Excel} from "@/utils/excel";

export default {
    data() {
        return {
            role_id: 0,
            page: 1,
            perpage: 10,
            total: 0,
            type: 1,
            user_name: '',
            doctor_name: '',
            search_date: '',
            start_date:'',
            end_date:'',
            tableData: [],
            allData: 0,
            allType: [
                {
                    id: 1,
                    name: '特属专家报表'
                },
                {
                    id: 2,
                    name: '单聊报表'
                },
            ],
            button_position: 'absolute',
            is_mobile: false,
        };
    },
    created() {
        if (isMobile()) {
            this.button_position = 'static'
            this.is_mobile = true
        }
    },
    mounted() {
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
        }
        this.getList();
        localStorage.setItem('prev_page', 'replytimeout_list')
    },
    methods: {

        // 预约列表
        getList() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'doctorReplyTimeoutList',
                params: {
                    start_date: this.start_date,
                    end_date: this.end_date,
                    type: this.type,
                    user_name: this.user_name,
                    doctor_name: this.doctor_name,
                },
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.tableData = [];
                    this.total = 0;
                    return;
                }
                if (res.data.data.list) {
                    for (let i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.allData = res.data.data.all_number;
                }

            });


        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },


        // 重置按钮
        resetForm() {
            this.user_name = "";
            this.doctor_name = "";
            this.search_date = "";
            this.start_date = "";
            this.end_date = "";
            this.type = 1;
            this.page = 1;
            this.getList();
        },
        dateChange(e){
            if (!e) {
                this.search_date = null
                this.start_date = ''
                this.end_date = ''
            }
        },
        // 搜索
        search() {
            if (this.search_date) {
                this.start_date = this.search_date[0];
                this.end_date = this.search_date[1];
            }
            this.page = 1;
            this.getList();
        },

        searchStatus() {
            this.page = 1;
            this.getList();
        },

        // 导出数据
        exportExcel() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'doctorReplyTimeoutList',
                params: {
                    start_date: this.start_date,
                    end_date: this.end_date,
                    type: this.type,
                    user_name: this.user_name,
                    doctor_name: this.doctor_name,
                },
            };
            let colums_list = null;
            if (this.type == 1) {
                colums_list = [
                    {title: "特属专家姓名", key: "doctor_name"},
                    {title: "特属专家联系电话", key: "doctor_mobile"},
                    {title: "特属专家单位", key: "hospital_name"},
                    {title: "特属专家科室", key: "department_name"},
                    {title: "超时未回复次数", key: "number"},
                ];
            } else {
                colums_list = [
                    {title: "特属专家姓名", key: "doctor_name"},
                    {title: "特属专家联系电话", key: "doctor_mobile"},
                    {title: "特属专家单位", key: "hospital_name"},
                    {title: "特属专家科室", key: "department_name"},
                    {title: "特属服务对象姓名", key: "user_name"},
                    {title: "特属服务对象联系电话", key: "user_mobile"},
                    {title: "超时未回复次数", key: "number"},
                ];
            }


            let export_data = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                let res_data = res.data;

                if (parseInt(res_data.code) != 0) {
                    this.$message.error(res_data.msg);
                    return false;
                }

                let list = res_data.data.list;
                let item = null;
                for (let i = 0; i < list.length; i++) {

                    item = {
                        doctor_name: list[i].doctor_name,
                        doctor_mobile: list[i].doctor_mobile,
                        hospital_name: list[i].hospital_name,
                        department_name: list[i].department_name,
                        number: list[i].number,
                    };
                    if (this.type == 2) {
                        item.user_name = list[i].user_name;
                        item.user_mobile = list[i].user_mobile;
                    }

                    export_data.push(item);
                }
                export2Excel(colums_list, export_data, "导出特属专家超时未回复报表");
            });
        },
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";
.docker_buttons {
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: 150px;
        height: 32px;
        line-height: 7px;
    }
}
.inputs .el-select {
    max-width: none !important;
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.inputs .el-input {width: 100% !important;}
</style>
